import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { propArrayShape, propBool, propFunc, propShape, propStr, } from '../../../../helpers/custom-prop-types';
import BlurText from '../../../Ui/Common/BlurText';
import CustomSlider from '../../../Ui/Slider';
import SectionArticlesDocument from './SectionArticlesDocument';
const SectionArticles = (props) => {
    const { config, dataAttributes, isBlur, relatedDocuments, relatedLinks, showPdfModal, size, } = props;
    return (_jsxs("div", Object.assign({ className: 'about-consultant-article-list' }, { children: [relatedDocuments.length > 0 && (_jsx(CustomSlider, Object.assign({ className: 'slick-slider', config: config, dataAttributes: dataAttributes, fillCount: size === 'pc' ? Math.max(0, 3 - relatedDocuments.length) : 0 }, { children: relatedDocuments.map((row) => (_jsx(SectionArticlesDocument, { isBlur: isBlur, row: row, showPdfModal: showPdfModal }, row.id))) }))), relatedLinks.length > 0 && (_jsx("ul", Object.assign({ className: 'relation-link-list' }, { children: relatedLinks.map((row) => isBlur ? (_jsx(BlurText, Object.assign({ component: 'li', isBlur: isBlur }, { children: row.title }), row.id)) : (_jsx("li", { children: _jsxs("a", Object.assign({ href: row.linkurl, rel: 'noopener noreferrer', target: '_blank' }, { children: [_jsx("span", { children: row.title }), _jsx("i", Object.assign({ className: 'material-icons' }, { children: "launch" }))] })) }, row.id))) })))] })));
};
SectionArticles.propTypes = {
    config: propShape(),
    dataAttributes: propShape(),
    isBlur: propBool().isRequired,
    relatedDocuments: propArrayShape().isRequired,
    relatedLinks: propArrayShape().isRequired,
    showPdfModal: propFunc().isRequired,
    size: propStr().isRequired,
};
SectionArticles.defaultProps = {
    config: {
        arrows: true,
        infinite: false,
        responsive: [
            {
                breakpoint: 800,
                settings: {
                    arrows: false,
                    dots: true,
                    slidesToShow: 1,
                },
            },
        ],
        slidesToShow: 3,
        speed: 300,
    },
    dataAttributes: {},
};
export default SectionArticles;
